import React, { Component } from 'react';
import Form from 'react-bootstrap/Form';
import 'toastr/build/toastr.min.css';
import { DisplayMessage } from '../../../services/helpers.js';
import DelayedRedirect from '../../../utils/DelayedRedirect';
import { Transition } from '../../../utils/ModalHelpers';
import { Button } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import Paper from '@material-ui/core/Paper';
import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import TextField from '@material-ui/core/TextField';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Select from '@material-ui/core/Select';
import moment from 'moment';
import { SelectTheme } from '../../../utils/utils.js';
import { ThemeProvider } from "@material-ui/core";
import appFetch from '../../../api/appFetch.js';
import ModifiedByInfo from "./../../Common/Footers/ModifiedByInfo";
import { InternalChatGroupsUrl, InternalChatGroupsWithIdUrl } from '../../../constants/apiUrls.js';
import OutletsDropdown from '../../Common/Dropdowns/OutletsDropdown.js';
import { ChatGroupUsages } from '../../../constants/chatGroupUsages.js';

export default class ChatGroupsEditing extends Component {
    constructor(props) {
        super(props);

        let chatGroupId = undefined;

        if (this.props !== undefined) {
            chatGroupId = this.props.chatgroupId;
        }

        this.state = {
            id: chatGroupId,
            outletId: 0,
            description: "",
            internalChatName: "",
            isActive: false,
            usageChat: false,
            usageTasks: false,
            modifiedOn: "",
            modifiedByName: "",
            modifiedByAvatar: "",
            redirect: false,
            accessibleMoboOutlets: [],
            editedChatGroupId: chatGroupId,
            requestInProgress: false,
            open: true,
            ChatGroupWasCreated: false,
        };
    }

    componentDidMount() {
        if (this.props.location !== undefined && this.props.location.state !== undefined && this.props.location.state.editedChatGroup !== undefined) {
            this.getEditedChatGroupDetails(this.props.location.state.editedChatGroup);
        } else {
            if (this.state.editedChatGroupId !== undefined) {
                this.getDataById();
            }
        }
    }

    getEditedChatGroupDetails = (editedChatGroup) => {
        this.setState({
            id: editedChatGroup.id,
            description: editedChatGroup.description,
            outletId: editedChatGroup.moboOutletID === null ? 0 : editedChatGroup.moboOutletID,
            internalChatName: editedChatGroup.chatName,
            isActive: editedChatGroup.isActiveValue,
            usageChat: Array.isArray(editedChatGroup.usages) && editedChatGroup.usages.includes(ChatGroupUsages.Chat),
            usageTasks: Array.isArray(editedChatGroup.usages) && editedChatGroup.usages.includes(ChatGroupUsages.Tasks),
            modifiedOn: editedChatGroup.modifiedOn,
            modifiedByName: editedChatGroup.modifiedByName,
            modifiedByAvatar: editedChatGroup.modifiedByAvatar,
        });
    }

    getDataById = async () => {
        this.setState({ requestInProgress: true });

        await appFetch({
            url: InternalChatGroupsUrl(),
            onError: (response) => {
                for (let i = 0; i < response.errors.length; i++) {
                    DisplayMessage(response.errors[i], "error");
                }
            },
            onSuccess: (response) => {
                let groupItem = [];
                let editedChatGroupId = parseInt(this.state.editedChatGroupId);
                response.forEach(function (rowData) {
                    if (rowData.id === editedChatGroupId) {
                        groupItem = rowData;
                    }
                });

                this.setState({
                    id: editedChatGroupId,
                    description: groupItem.description,
                    outletId: groupItem.moboOutletID === null ? 0 : groupItem.moboOutletID,
                    internalChatName: groupItem.internalDialogName,
                    isActive: groupItem.isActive,
                    usageChat: Array.isArray(groupItem.usages) && groupItem.usages.includes(ChatGroupUsages.Chat),
                    usageTasks: Array.isArray(groupItem.usages) && groupItem.usages.includes(ChatGroupUsages.Tasks),
                    modifiedOn: groupItem.modifiedOn,
                    modifiedByName: groupItem.modifiedByName,
                    modifiedByAvatar: groupItem.modifiedByAvatar,
                });
            },
            onFinalize: () => {
                this.setState({ requestInProgress: false });
            }
        })
    };

    isFormValid = () => {
        const { description, internalChatName, usageChat, usageTasks } = this.state;

        if (!description || description.trim().length === 0) {
            return false;
        }

        if (!internalChatName || internalChatName.trim().length === 0) {
            return false;
        }

        if (!usageChat && !usageTasks) {
            return false;
        }

        return true;
    }

    handleClose = () => {
        this.setState({ open: false, redirect: "/chatgroups" });
    };

    handleChange = e => {
        if (e.target.name === "internalChatName") {
            this.setState({ [e.target.name]: e.target.value.replace(/ /g, '') });
            return;
        }

        this.setState({ [e.target.name]: e.target.value.replace(/^\s+/, "") });
    };

    handleChangeCheckBox = e => {
        this.setState({ [e.target.name]: e.target.checked });
    };

    handleChangeOutlet = e => {
        this.setState({ outletId: parseInt(e.target.value) });
    };

    handleSubmit = () => {
        this.saveEditedChatGroup();
    }

    saveEditedChatGroup = () => {
        this.setState({ requestInProgress: true });
        let resources = this.props.resources;

        if ((this.state.description.length > 0 && this.state.description.trim().length <= 0) || this.state.description.trim().length > 100) {
            DisplayMessage(resources["InvalidDescripton"], "error");
            return;
        }

        if ((this.state.internalChatName.length > 0 && this.state.internalChatName.trim().length <= 0) || this.state.internalChatName.length > 20) {
            DisplayMessage(resources["InvalidChatName"], "error");
            return;
        }

        var bodyJson = {};
        bodyJson.moboOutletId = this.state.outletId ? this.state.outletId : null;

        if (this.state.description !== "") {
            bodyJson.description = this.state.description;
        }

        if (this.state.internalChatName !== "") {
            bodyJson.internalChatName = this.state.internalChatName.replace(/ /g, '');
        }

        bodyJson.isActive = this.state.isActive;

        var usages = [];
        if (this.state.usageChat) usages.push(ChatGroupUsages.Chat);
        if (this.state.usageTasks) usages.push(ChatGroupUsages.Tasks);
        bodyJson.usages = usages;

        const json = JSON.stringify(bodyJson);

        const url = InternalChatGroupsWithIdUrl(this.state.id);

        appFetch({
            url: url,
            method: 'PATCH',
            body: json,
            onSuccess: (response) => {
                if (response.id !== undefined) {
                    this.setState({
                        id: response.id,
                        description: response.description,

                        ChatGroupWasCreated: true,
                        redirect: "/chatgroups"
                    });

                    DisplayMessage(resources["ChatGroupWasSaved"], "success");
                }
            },
            onError: (response) => {
                for (let i = 0; i < response.errors.length; i++) {
                    DisplayMessage(response.errors[i], "error");
                }
            },
            onFinalize: () => {
                this.setState({ requestInProgress: false });
            }
        })
    }

    renderModifiedByInfo = () => {
        if (this.state.id > 0) {
          return (
            <ModifiedByInfo
              resources={this.props.resources}
              modifiedByAvatar={this.state.modifiedByAvatar}
              modifiedOn={this.state.modifiedOn}
              modifiedByName={this.state.modifiedByName}
              className="mt-3"
            />
          );
        }
        return;
    }

    renderForm() {
        const { isActive, description, internalChatName, outletId } = this.state;
        var resources = this.props.resources;

        var helperTextDescription = description.trim().length <= 0 ? "helper-text-red" : "helper-text-grey";
        var helperTextChatName = internalChatName === "" ? "helper-text-red" : "helper-text-grey";

        return (
            <Paper elevation={3} className="p-4 mt-3 mb-3">
                <Form>
                    <Form.Group className="pt-3" style={{ display: "flex" }}>
                        <div className="col-md-3"></div>
                        <ThemeProvider theme={SelectTheme}>
                            <TextField className={`col-6 ${helperTextDescription}`} id="chatgroup-description" value={description} label={resources["Description"]}
                                helperText={resources["InputOfDescriptionIsMandatory"]}
                                variant="outlined" name="description" onChange={this.handleChange} inputProps={{ maxLength: 100 }} />
                        </ThemeProvider>
                    </Form.Group>


                    <Form.Group className="d-flex">
                        <div className="col-3"></div>
                        <ThemeProvider theme={SelectTheme}>
                            <TextField className={`col-6 ${helperTextChatName}`} id="chatgroup-chatname" value={internalChatName} label={resources["ChatName"]}
                                helperText={resources["InputOfChatNameIsMandatory"]}
                                variant="outlined" name="internalChatName" onChange={this.handleChange} inputProps={{ maxLength: 20 }} />
                        </ThemeProvider >
                    </Form.Group>

                    <Form.Group className="d-flex" >
                        <div className="col-3"></div>
                        <OutletsDropdown
                            resources={resources}
                            outlets={this.props.accessibleMoboOutlets}
                            outlet={outletId}
                            onOutletChange={this.handleChangeOutlet}
                            containerClass="col-6 helper-text-red"
                        />
                    </Form.Group>

                    <Form.Group style={{ display: "flex" }}>
                        <div className="col-md-3"></div>
                        <div className="col-md-6 p-0">
                            <div className="mb-1">
                                <strong style={{ fontSize: "14px" }}>{resources["LabelUsage"]}</strong><span style={{ color: "#f44336", marginLeft: "2px" }}>*</span>
                                <span style={{ fontSize: "14px", fontWeight: "normal", color: "rgba(0,0,0,0.54)" }}>
                                    {" "}({resources["LabelUsageSelectAtLeastOne"]})
                                </span>
                            </div>
                            <FormControlLabel className="d-block m-0"
                                control={<Checkbox id="chatgroup-usage-chat" checked={this.state.usageChat} onChange={this.handleChangeCheckBox} name="usageChat" color="primary" />}
                                label={resources["LabelUsageChat"]} />
                            <FormControlLabel className="d-block m-0"
                                control={<Checkbox id="chatgroup-usage-tasks" checked={this.state.usageTasks} onChange={this.handleChangeCheckBox} name="usageTasks" color="primary" />}
                                label={resources["LabelUsageTasks"]} />
                        </div>
                    </Form.Group>
                    <Form.Group style={{ display: "flex" }} >
                        <div className="col-md-3 "> </div>
                        <FormControlLabel className="col-md-6 text-right label-mt my-auto p-0"
                            control={<Checkbox id="chatgroup-is-active" checked={isActive} onChange={this.handleChangeCheckBox} name="isActive" color="primary" />}
                            label={resources["IsActive"]} />
                        <div className="col-md-4"> </div>
                    </Form.Group>
                    {this.renderModifiedByInfo()}
                </Form>
            </Paper>
        );
    }

    renderMain() {
        const { loading } = this.state;

        if (loading) {
            return (<div className="centered-loader"><CircularProgress /></div>);
        }

        return (<div className={"py-4 grey " + (this.state.loading ? 'fadeOut' : 'fadeIn')}>
            {this.renderForm()}
        </div>);
    }

    render() {
        const { redirect, open, ChatGroupWasCreated, outletId, requestInProgress } = this.state;
        const { resources } = this.props;

        const isSaveButtonDisabled = requestInProgress || !this.isFormValid() || redirect

        return (
            <div>
                {redirect && <DelayedRedirect to={{ pathname: redirect, state: { outletId, refreshGrid: ChatGroupWasCreated } }} delay={250} />}
                <Dialog fullScreen open={open} onClose={this.handleClose} TransitionComponent={Transition}>
                    <AppBar className="position-sticky">
                        <Toolbar>
                            <IconButton id="close-edit-chatgroup" edge="start" color="inherit" onClick={this.handleClose} aria-label="close">
                                <CloseIcon />
                            </IconButton>
                            <Typography variant="h6" style={{ flex: 1 }}>
                                {resources["EditChatGroup"]}
                            </Typography>
                            <Button id="chatgroup-save" color="inherit" disabled={isSaveButtonDisabled} onClick={this.handleSubmit}>{resources["Save"]}</Button>
                        </Toolbar>
                    </AppBar>
                    <div className="container">
                        {this.renderMain()}
                    </div>

                </Dialog>
            </div >
        );
    }
}